
import { RegistrationFormValues } from '@/schemas/registrationSchema';
import { formatQRCode } from '@/utils/qrCodeUtils';
import { formatTShirtSize } from '@/utils/formatUtils';

// Function to generate a QR code value for the registration
// We'll use the standardized formatQRCode utility for consistency
export const generateQRData = (formData: RegistrationFormValues, code: string, totalAmount: number): string => {
  // Pre-process the code for consistency
  return formatQRCode(code);
};

// Improved confirmation code generator with better randomness and reliability
export const generateConfirmationCode = (): string => {
  // Use multiple sources of randomness for better uniqueness
  const timestamp = new Date().getTime().toString(36).substring(0, 2).toUpperCase();
  const randomHex = Math.floor(Math.random() * 0xFFFFF).toString(16).padStart(4, '0').toUpperCase();
  
  // Combine for increased uniqueness and ensure exactly 6 characters
  const codeBase = `${timestamp}${randomHex}`.substring(0, 6).padStart(6, '0').toUpperCase();
  
  // Add the LHP- prefix as required
  return `LHP-${codeBase}`;
};

// Enhanced accent removal with better handling of Vietnamese characters
export const removeAccents = (str: string): string => {
  if (!str) return '';
  
  return str.normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')  // Remove accents
    .replace(/đ/g, 'd').replace(/Đ/g, 'D')  // Replace Vietnamese d
    .replace(/[^\x00-\x7F]/g, '')  // Remove non-ASCII chars
    .replace(/[^a-zA-Z0-9 ]/g, '')  // Remove special chars
    .trim();
};

// Re-export formatTShirtSize for convenience
export { formatTShirtSize };
